import React, { useEffect, useState } from 'react';
import { getShortMessageTableData } from '../../utils/services/dashboardAPI';
import { StyledHeading } from '../../components/Dashboard/styles.js';
import { Table, Empty } from 'antd';
import { withTranslation } from 'react-i18next';
import { FAILED_SHORT_MESSAGE_TEMPLATES_TABLE } from './TranslationValues.js';

const NAMESPACES = ['FAILED_SHORT_MESSAGE_TEMPLATES_TABLE'];

const MessageFailedTransactions = props => {
  const { isTableVisible, viewType, failedIds, t } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isTableVisible) fetchTableData();
  }, [isTableVisible, viewType, failedIds.whatsapp, failedIds.sms, failedIds.call]);

  const fetchTableData = async () => {
    setLoading(true);
    let ids = viewType === 0 ? failedIds.whatsapp : viewType === 1 ? failedIds.sms : failedIds.call;
    const res = await getShortMessageTableData(ids);
    if (res && res?.data && res?.statusCode === 1542) {
      setData(res.data);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.ID_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.ID_COLUMN_TITLE.value),
      width: '10%',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.MESSAGE_TYPE_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.MESSAGE_TYPE_COLUMN_TITLE.value),
      width: '10%',
      dataIndex: 'messageType',
      key: 'messageType',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.STATUS_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.STATUS_COLUMN_TITLE.value),
      width: '10%',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.DELIVERY_STATUS_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.DELIVERY_STATUS_COLUMN_TITLE.value),
      width: '15%',
      dataIndex: 'deliveryStatus',
      key: 'deliveryStatus',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILURE_DESCRIPTION_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILURE_DESCRIPTION_COLUMN_TITLE.value),
      width: '15%',
      dataIndex: 'failuredescription',
      key: 'failuredescription',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILURE_REASON_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILURE_REASON_COLUMN_TITLE.value),
      width: '15%',
      dataIndex: 'failurereason',
      key: 'failurereason',
    },
    {
      title: t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.TIME_COLUMN_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.TIME_COLUMN_TITLE.value),
      width: '15%',
      dataIndex: 'time',
      key: 'time',
    },
  ];

  const tableProps = {
    loading,
  };

  return (
    <>
      <StyledHeading>
        <h2>{t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILED_TEMPLATES_TABLE_TITLE.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.FAILED_TEMPLATES_TABLE_TITLE.value)}</h2>
      </StyledHeading>
      <Table
        {...tableProps}
        className="failed-templates-table"
        dataSource={data || []}
        columns={columns}
        locale={{ emptyText: <Empty description={t(FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.EMPTY_TABLE_DESCRIPTION.key, FAILED_SHORT_MESSAGE_TEMPLATES_TABLE.EMPTY_TABLE_DESCRIPTION.value)}/> }}
      />
    </>
  );
};

export default withTranslation(NAMESPACES)(MessageFailedTransactions);
